__webpack_require__.p = "https://qa-digital-promotions-mfe.digital.vpsvc.com/";